import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import usermgtSlice from "./usermgtSlice";
import ldapSlice from "./ldapSlice";
import levelSlice from "./levelSlice";
import samlIdentityProviderSlice from "./samlIdentityProviderSlice";
import socialIdentityProviderSlice from "./socialIdentityProviderSlice";
import oidcIdentityProviderSlice from "./oidcIdentityProviderSlice";
import mfaSlice from "./mfaSlice";

export const UsermgtContext = React.createContext(null);

const usermgtStore = configureStore({
    reducer: {
        usermgtStore: usermgtSlice,
        ldapStore: ldapSlice,
        levelStore: levelSlice,
        samlIdentityProviderStore: samlIdentityProviderSlice,
        socialIdentityProviderStore: socialIdentityProviderSlice,
        oidcIdentityProviderStore: oidcIdentityProviderSlice,
        mfaStore: mfaSlice,
    },
});
export default usermgtStore;

export type State = ReturnType<typeof usermgtStore.getState>;
export type Dispatch = typeof usermgtStore.dispatch;
export const useUsermgtSelector: TypedUseSelectorHook<State> = createSelectorHook(UsermgtContext);
export const useUsermgtDispatch = createDispatchHook<Dispatch>(UsermgtContext);
